import loadScript from 'load-script';

let loaded = false;

/**
 * This module / function allows the dynamic loading of wbads client
 * javascript library
 * @param  {Function} callback - the function to execute once wbads client api is loaded
 * @param  {Object}   options  - options for the loading of the script
 * @return {void}
 */
export default function (params, callback = null, options = {}) {
  if (loaded && typeof callback === 'function') {
    callback();
    return false;
  }

  if (loaded) {
    return false;
  }

  const JAD_URL = `https://cdn.lib.getjad.io/library/${params.network}/${params.site}`;

  loadScript(JAD_URL, options, () => {
    loaded = true;
    if (typeof callback === 'function') {
      callback();
    }
  });
}
